import React from 'react';
import MenuItem from '@mui/material/MenuItem';

import { Hardware_Vendor } from '@occc/graphql';
import { Select } from '@occc-app/design-system';

import PartnerIcon from './PartnerIcon';
import gilbarco from './assets/gilbarco_mini_logo.png';
import verifone from './assets/verifone_mini_logo.png';
import ncr from './assets/ncr_mini_logo.png';
import oc from './assets/open_commerce_mini_logo.png';
import comdata from './assets/comdata_logo.png';

import { isRequired } from '../../utils';

const PluginTypeSelect: React.FC = () => (
  <Select
    name='siteSystemConfiguration.hardwareVendor'
    label='Select Vendor Type'
    required={true}
    fieldProps={{
      validate: isRequired,
    }}
  >
    <MenuItem value={Hardware_Vendor.Verifone}>
      <PartnerIcon path={verifone} />
      Verifone
    </MenuItem>
    <MenuItem value={Hardware_Vendor.Gilbarco}>
      <PartnerIcon path={gilbarco} />
      Gilbarco
    </MenuItem>
    <MenuItem value={Hardware_Vendor.Ncr}>
      <PartnerIcon path={ncr} />
      NCR-RLM
    </MenuItem>
    <MenuItem value={Hardware_Vendor.NcrPes}>
      <PartnerIcon path={ncr} />
      NCR-PES
    </MenuItem>
    <MenuItem value={Hardware_Vendor.Stuzo}>
      <PartnerIcon path={oc} />
      Stuzo
    </MenuItem>
    <MenuItem value={Hardware_Vendor.Comdata}>
      <PartnerIcon path={comdata} />
      Comdata
    </MenuItem>
  </Select>
);

export default PluginTypeSelect;
